import {
  FieldValue,
  RelativeField,
  TagBoxValueExpressions,
  SimpleFormContextValue
} from '../SimpleForm';
import { RecordValue } from './types';

type HandleArrayValProps = {
  value: RecordValue[];
  valueExpr: string | undefined;
  formItemValue: FieldValue;
  fieldName: string;
  relativeFields: RelativeField[];
} & SimpleFormContextValue;

export const handleArrayVal = ({
  value,
  valueExpr,
  formItemValue,
  getFormItemValue,
  setFormItemValue,
  fieldName,
  relativeFields
}: HandleArrayValProps) => {
  const valueExpressions = value.map((x) => x[valueExpr || 'Id'] || x) as any[];

  const safeFormItemVal = (formItemValue || []) as TagBoxValueExpressions;

  const formValLen = safeFormItemVal.length;
  const valExpLen = valueExpressions.length;

  if (valExpLen === formValLen) {
    return;
  }

  setFormItemValue(fieldName, valueExpressions);

  if (valExpLen < formValLen) {
    const deletedIndex = safeFormItemVal.findIndex(
      (id) => !valueExpressions.includes(id)
    );

    relativeFields.forEach(({ local }) => {
      const relFieldVal = getFormItemValue(local);

      const newRelFieldVal = [...(relFieldVal as TagBoxValueExpressions)];
      newRelFieldVal.splice(deletedIndex, 1);

      setFormItemValue(local, newRelFieldVal as TagBoxValueExpressions);
    });

    return;
  }

  const newSelectedVal = value.find(
    (x) => typeof x !== 'string'
  ) as RecordValue;

  relativeFields.forEach(({ local, relative }) => {
    const relFieldVal = getFormItemValue(local);

    const newRelFieldVal = !relFieldVal
      ? [newSelectedVal[relative]]
      : [...(relFieldVal as TagBoxValueExpressions), newSelectedVal[relative]];

    setFormItemValue(local, newRelFieldVal as TagBoxValueExpressions);
  });
};
